import { CommonMenuConfig } from './menu';
import { ResearchUI } from './commonInterface';
import { createMenuView } from './menu/commonMenuView';

export function createCommonUI(): ResearchUI {
    return { createMenu: createMenuView };
}
